module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="base-league-data" >\n	<div class="table-item type head_to_head">\n		<p>H2H</p>\n	</div>\n	<div class="table-item avatar">\n		<picture>\n			<source srcset="'+
((__t=( avatar ))==null?'':_.escape(__t))+
'" class="js-display-img" type="image/png">\n			<img src="/assets/images/test-avatar.png?v=1" alt="League avatar">\n		</picture>\n	</div>\n	<div class="table-item name">\n		<a href="javascript:void(0)" class="league-name show-more-info">\n			<p>'+
((__t=( name ))==null?'':_.escape(__t))+
'</p>\n			<div class="more-info">\n				<h5>League settings</h5>\n				<p>\n					<strong>League Name:</strong>\n					'+
((__t=( name ))==null?'':_.escape(__t))+
'\n				</p>\n				<p>\n					<strong>League Type:</strong>\n					Head to head\n				</p>\n				<p>\n					<strong>Privacy:</strong>\n					'+
((__t=( (privacy == 1) ? 'Public' : 'Private' ))==null?'':_.escape(__t))+
'\n				</p>\n				<p>\n					<strong>Start Round:</strong>\n					'+
((__t=( start_round ))==null?'':_.escape(__t))+
'\n				</p>\n				<!--<p>\n					<strong>Coaches Box:</strong>\n					'+
((__t=( (coaches_box == 1) ? 'On' : 'Off' ))==null?'':_.escape(__t))+
'\n				</p>-->\n			</div>\n		</a>\n		<div class="user-info">\n			'+
((__t=( lastname +' '+firstname ))==null?'':_.escape(__t))+
' | Starts: Round '+
((__t=( start_round ))==null?'':_.escape(__t))+
'\n		</div>\n	</div>\n	<div class="table-item size">\n		'+
((__t=( num_teams ))==null?'':_.escape(__t))+
'/'+
((__t=( size ))==null?'':_.escape(__t))+
'\n	</div>\n	<div class="table-item arrow">\n		<a href="javascript:void(0)" class="join-to-league" data-code="'+
((__t=( code ))==null?'':_.escape(__t))+
'" data-id="'+
((__t=( id ))==null?'':_.escape(__t))+
'"></a>\n	</div>\n</div>\n\n\n';
}
return __p;
};
